import { JSX } from 'react'

import { IconProps } from '../../icon'

const Notification: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M35.7212 31.2769L34.6471 29.1286C33.9941 27.8311 33.6536 26.3989 33.6529 24.9463V20.5698C33.6509 18.3446 32.8374 16.1965 31.3648 14.5283C29.8922 12.8601 27.8617 11.7863 25.654 11.5081V9.1427C25.654 8.83964 25.5336 8.54899 25.3193 8.33469C25.105 8.12039 24.8144 8 24.5113 8C24.2082 8 23.9176 8.12039 23.7033 8.33469C23.489 8.54899 23.3686 8.83964 23.3686 9.1427V11.5081C21.1609 11.7863 19.1304 12.8601 17.6578 14.5283C16.1852 16.1965 15.3717 18.3446 15.3697 20.5698V24.9463C15.369 26.3989 15.0285 27.8311 14.3755 29.1286L13.3014 31.2769C13.0832 31.7145 12.9805 32.2006 13.0031 32.6891C13.0256 33.1776 13.1727 33.6522 13.4303 34.0678C13.6879 34.4834 14.0476 34.8263 14.475 35.0638C14.9024 35.3013 15.3835 35.4256 15.8725 35.4249H18.8663C19.0927 36.7419 19.7901 37.9318 20.8286 38.7727C21.8672 39.6136 23.176 40.0483 24.5113 39.9957C25.8466 40.0483 27.1555 39.6136 28.194 38.7727C29.2326 37.9318 29.93 36.7419 30.1563 35.4249H33.1502C33.6391 35.4256 34.1202 35.3013 34.5476 35.0638C34.9751 34.8263 35.3347 34.4834 35.5923 34.0678C35.8499 33.6522 35.997 33.1776 36.0196 32.6891C36.0421 32.2006 35.9394 31.7145 35.7212 31.2769ZM24.5113 37.7103C23.7778 37.7524 23.051 37.5512 22.4436 37.138C21.8361 36.7247 21.382 36.1226 21.1518 35.4249H27.8709C27.6406 36.1226 27.1865 36.7247 26.5791 37.138C25.9716 37.5512 25.2448 37.7524 24.5113 37.7103ZM33.6529 32.8653C33.6025 32.9503 33.5305 33.0204 33.4442 33.0686C33.3579 33.1168 33.2604 33.1412 33.1616 33.1395H15.8725C15.776 33.1357 15.6819 33.108 15.5987 33.0589C15.5156 33.0098 15.446 32.9407 15.3961 32.858C15.3462 32.7753 15.3177 32.6815 15.3131 32.585C15.3085 32.4885 15.3279 32.3924 15.3697 32.3053L16.4438 30.157C17.2465 28.5377 17.6612 26.7537 17.6551 24.9463V20.5698C17.6551 18.7514 18.3774 17.0075 19.6632 15.7217C20.949 14.4359 22.6929 13.7135 24.5113 13.7135C26.3297 13.7135 28.0736 14.4359 29.3594 15.7217C30.6452 17.0075 31.3675 18.7514 31.3675 20.5698V24.9463C31.3685 26.7555 31.7911 28.5396 32.6017 30.157L33.6529 32.3053C33.7032 32.3901 33.7298 32.4868 33.7298 32.5853C33.7298 32.6838 33.7032 32.7805 33.6529 32.8653Z'
      fill='black'
    />
  </svg>
)

export default Notification
